import { Controller } from "@hotwired/stimulus"
import { planningMutation } from "../planning_mutation"

// Styled confirmation dialog for removing a planned employee (allocation) or a trade demand from
// the capacity board. Opens on the `planning:confirm-remove` document event (dispatched by the
// delegated board controller when a chip's ✕ is clicked) with { url, title, body }. On confirm it
// DELETEs the given URL and renders the returned Turbo Stream.
export default class extends Controller {
  static targets = ["root", "title", "body", "submit", "spinner"]

  connect() {
    this.url = null
    this.boundOpen = this.open.bind(this)
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener("planning:confirm-remove", this.boundOpen)
  }

  disconnect() {
    document.removeEventListener("planning:confirm-remove", this.boundOpen)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  open(event) {
    const detail = event.detail || {}
    this.url = detail.url
    this.titleTarget.textContent = detail.title || ""
    this.bodyTarget.textContent = detail.body || ""

    this.rootTarget.classList.remove("hidden")
    this.rootTarget.classList.add("flex")
    document.addEventListener("keydown", this.boundKeydown)
  }

  close() {
    this.rootTarget.classList.add("hidden")
    this.rootTarget.classList.remove("flex")
    this.url = null
    this.setPending(false)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  // Disable the Löschen button + show its spinner while the delete is in flight; the dialog stays
  // open until the server replies (see confirm()).
  setPending(pending) {
    if (this.hasSubmitTarget) this.submitTarget.disabled = pending
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.toggle("hidden", !pending)
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  backdrop(event) {
    if (event.target === this.rootTarget) this.close()
  }

  async confirm() {
    if (!this.url) return
    const url = this.url
    this.setPending(true)
    const { ok } = await planningMutation({
      url,
      method: "DELETE",
      component: "planning-confirm-dialog",
    })
    if (ok) {
      this.close()
    } else {
      this.setPending(false)
    }
  }
}
